/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type MintUserSessionResponseBody = {
  /**
   * The minted user-session JWT. Send as `Authorization: Bearer` on MCP requests to the bound /mcp/{slug} surface.
   */
  accessToken: string;
  /**
   * Lifetime of the access token in seconds.
   */
  expiresIn: number;
};

/** @internal */
export const MintUserSessionResponseBody$inboundSchema: z.ZodMiniType<
  MintUserSessionResponseBody,
  unknown
> = z.pipe(
  z.object({
    access_token: z.string(),
    expires_in: z.int(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "access_token": "accessToken",
      "expires_in": "expiresIn",
    });
  }),
);

export function mintUserSessionResponseBodyFromJSON(
  jsonString: string,
): SafeParseResult<MintUserSessionResponseBody, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => MintUserSessionResponseBody$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'MintUserSessionResponseBody' from JSON`,
  );
}
